export const state_style_pre = (feature) => {
  if (
    feature.properties &&
    feature.properties.crop_status == null
  ) {
    return {
      color: "black",
      weight: 0.9,
      fillColor: "white",
      fillOpacity: 0.8,
    };
  } else if (
    feature.properties &&
    feature.properties.infest_level?.previous_week === 3
  ) {
    return {
      color: "black",
      weight: 0.4,
      fillColor: "red",
      fillOpacity: 0.8,
    };
  } else if (
    feature.properties &&
    feature.properties.infest_level?.previous_week === 2
  ) {
    return {
      color: "black",
      weight: 0.4,
      fillColor: "orange",
      fillOpacity: 0.8,
    };
  } else if (
    feature.properties &&
    feature.properties.infest_level?.previous_week === 1
  ) {
    return {
      color: "black",
      weight: 0.4,
      fillColor: "yellow",
      fillOpacity: 0.8,
    };
  } else if (
    feature.properties &&
    feature.properties.infest_level?.previous_week === 0
  ) {
    return {
      color: "black",
      weight: 0.4,
      fillColor: "green",
      fillOpacity: 0.8,
    };
  } else if (
    feature.properties &&
    feature.properties.infest_level?.previous_week == null
  ) {
    return {
      color: "black",
      weight: 0.4,
      fillColor: "magenta",
      fillOpacity: 0.8,
    };
  }
};
export const state_style_curr = (feature) => {
  if (
    feature.properties &&
    feature.properties.crop_status == null
  ) {
    return {
      color: "black",
      weight: 0.9,
      fillColor: "white",
      fillOpacity: 0.8,
    };
  } else if (
    feature.properties &&
    feature.properties.infest_level?.current_week_forecast === 3
  ) {
    return {
      color: "black",
      weight: 0.4,
      fillColor: "red",
      fillOpacity: 0.8,
    };
  } else if (
    feature.properties &&
    feature.properties.infest_level?.current_week_forecast === 2
  ) {
    return {
      color: "black",
      weight: 0.4,
      fillColor: "orange",
      fillOpacity: 0.8,
    };
  } else if (
    feature.properties &&
    feature.properties.infest_level?.current_week_forecast === 1
  ) {
    return {
      color: "black",
      weight: 0.4,
      fillColor: "yellow",
      fillOpacity: 0.8,
    };
  } else if (
    feature.properties &&
    feature.properties.infest_level?.current_week_forecast === 0
  ) {
    return {
      color: "black",
      weight: 0.4,
      fillColor: "green",
      fillOpacity: 0.8,
    };
  } else if (
    feature.properties &&
    feature.properties.infest_level?.current_week_forecast == null
  ) {
    return {
      color: "black",
      weight: 0.4,
      fillColor: "magenta",
      fillOpacity: 0.8,
    };
  }
};
export const state_style_next = (feature) => {
  if (
    feature.properties &&
    feature.properties.crop_status == null
  ) {
    return {
      color: "black",
      weight: 0.9,
      fillColor: "white",
      fillOpacity: 0.8,
    };
  } else if (
    feature.properties &&
    feature.properties.infest_level?.next_week_forecast === 3
  ) {
    return {
      color: "black",
      weight: 0.4,
      fillColor: "red",
      fillOpacity: 0.8,
    };
  } else if (
    feature.properties &&
    feature.properties.infest_level?.next_week_forecast === 2
  ) {
    return {
      color: "black",
      weight: 0.4,
      fillColor: "orange",
      fillOpacity: 0.8,
    };
  } else if (
    feature.properties &&
    feature.properties.infest_level?.next_week_forecast === 1
  ) {
    return {
      color: "black",
      weight: 0.4,
      fillColor: "yellow",
      fillOpacity: 0.8,
    };
  } else if (
    feature.properties &&
    feature.properties.infest_level?.next_week_forecast === 0
  ) {
    return {
      color: "black",
      weight: 0.4,
      fillColor: "green",
      fillOpacity: 0.8,
    };
  } else if (
    feature.properties &&
    feature.properties.infest_level?.next_week_forecast == null
  ) {
    return {
      color: "black",
      weight: 0.4,
      fillColor: "magenta",
      fillOpacity: 0.8,
    };
  }
};
export const districts_style = {
  color: "black",
  weight: 0.9,
  fillColor: "blue",
  fillOpacity: 0.1,
};
export const india_style = {
  color: "black",
  weight: 1,
  fillColor: "blue",
  fillOpacity: 0.1,
};





